skrilla.directive('marketPurchaseDetails',function() {
    return {
        templateUrl: 'directives/marketPurchases/marketPurchaseDetails.html',
        scope: {
            purchase: "="
        },
        controller: function($scope, searchService, cacheService, modalService, currencyService, validationService){
            var validation = validationService;
            $scope.validate = {};

            $scope.approve = function(){
                if(validateForm()) {
                    const request = {...$scope.purchase, audCost: currencyService.multiply($scope.purchase.audCost, "AUD")}
                    searchService.put("markets/purchases/" + $scope.purchase.id + "/approve", request, "Purchase successfully approved").then(function (response) {
                        $scope.purchase.state = "APPROVED";
                        modalService.dismissAll()
                    }, function (response) {
                        $scope.purchase.audCost = currencyService.divide($scope.purchase.audCost, "AUD");
                    });
                }
            }

            $scope.decline = function(){
                modalService.confirm("Are you sure you'd like to decline this purchase?", function(){
                    searchService.put("markets/purchases/" + $scope.purchase.id + "/decline", {}, "Purchase successfully declined").then(function(response){
                        $scope.purchase.state = "DECLINED";
                        modalService.dismissAll()
                    });
                })
            }


            function validateForm(){
                var purchase = $scope.purchase;
                var tracking = purchase.transportType === "PHYSICAL" ? "tracking" : "activation";
                var inputs = [
                    validation.buildFieldValidationObj("audCost", !validation.isEmpty(purchase.audCost) &&  !isNaN(purchase.audCost), "Please enter a valid AUD Cost"),
                    validation.buildFieldValidationObj("receiptReference", !validation.isEmpty(purchase.receiptReference), "Please enter a receipt reference"),
                    validation.buildFieldValidationObj("trackingUri", !validation.isEmpty(purchase.trackingUri)  && purchase.trackingUri.startsWith("https://"), "Please enter a " + tracking + " URL"),
                    validation.buildFieldValidationObj("trackingCode", !validation.isEmpty(purchase.trackingCode), "Please enter a " + tracking + " code")
                ];
                return validation.validateForm(inputs, $scope.validate)
            }

            $scope.formatAddress = function (purchase){
                var address = "";
                if(purchase.address) {
                    if (purchase.address.unit) {
                        address += purchase.address.unit + " / ";
                    }
                    if (purchase.address.streetNumber) {
                        address += purchase.address.streetNumber + ", ";
                    }
                    if (purchase.address.street) {
                        address += purchase.address.street + ", ";
                    }
                    if (purchase.address.suburb) {
                        address += purchase.address.suburb + ", ";
                    }
                    if (purchase.address.state) {
                        address += purchase.address.state + ", ";
                    }
                    if (purchase.address.postCode) {
                        address += purchase.address.postCode + ", ";
                    }
                    if (purchase.address.country) {
                        address += purchase.address.country;
                    }
                }
                return address;
            }
        }
    };
});
